module.exports = __webpack_public_path__ + "img/09_Steuerung-Preis.070232e4.svg";